import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlConsultaConvenioParceriaConcedido = '/service/contabilidade/transparencia/convenio/'

class ConsultaConvenioParceriaConcedidoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            exercicio: {
                inicio: filtro.exercicioInicial,
                fim: filtro.exercicioFinal,
            },
            codigo: {
                inicio: filtro.codigoInicial,
                fim: filtro.codigoFinal,
            },
            tipo: filtro.tipo.length > 0 ? filtro.tipo.map(e => e.value) : [],
            dataAssinaturaInicial: filtro.assinaturaInicial ? moment(filtro.assinaturaInicial).format() : null,
            dataAssinaturaFinal: filtro.assinaturaFinal ? moment(filtro.assinaturaFinal).format() : null,
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value) : this.state.adms,
            descricaoLocalFisico: filtro.descricaoLocalFisico,
            nomeConvenente: filtro.convenente,
            nomeConcedente: filtro.concedente,
            interveniente: filtro.interveniente,
            observacao: filtro.objeto,
            situacao: filtro.situacao ? filtro.situacao.value : '',
            exercicioLicitacao: {
                inicio: filtro.exercicioLicitacaoInicial,
                fim: filtro.exercicioLicitacaoFinal,
            },
            numeroLicitacao: {
                inicio: filtro.numeroLicitacaoInicial,
                fim: filtro.numeroLicitacaoFinal,
            },
            modalidade: filtro.modalidadeLicitacao.length ? filtro.modalidadeLicitacao.map(e => e.value) : [],
            repasseConcedido: 'S',
        }
        return this.conex.post(urlConsultaConvenioParceriaConcedido + 'convenioParceriaConcedida/', JSON.stringify(data))
    }
}

export default ConsultaConvenioParceriaConcedidoService
